export default "__VITE_ASSET__CeYUxyV4__"